import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faHome } from '@fortawesome/free-solid-svg-icons';

const Breadcrumbs = ({ customCrumbs }) => {
  const location = useLocation();

  // If custom breadcrumbs provided, use them
  if (customCrumbs) {
    return (
      <nav aria-label="Breadcrumb" className="mb-6">
        <ol className="flex items-center gap-2 text-sm text-neutral-600">
          <li>
            <Link to="/" className="hover:text-primary-600 transition-colors" aria-label="Startsida">
              <FontAwesomeIcon icon={faHome} />
            </Link>
          </li>
          {customCrumbs.map((crumb, index) => (
            <React.Fragment key={index}>
              <li aria-hidden="true">
                <FontAwesomeIcon icon={faChevronRight} className="text-xs text-neutral-400" />
              </li>
              <li>
                {crumb.path ? (
                  <Link to={crumb.path} className="hover:text-primary-600 transition-colors">
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="text-neutral-900 font-medium" aria-current="page">
                    {crumb.label}
                  </span>
                )}
              </li>
            </React.Fragment>
          ))}
        </ol>
      </nav>
    );
  }

  // Auto-generate breadcrumbs from path
  const pathnames = location.pathname.split('/').filter(x => x);

  if (pathnames.length === 0) return null;

  const breadcrumbNameMap = {
    'kommuner': 'Kommuner',
    'kommun': 'Kommun',
    'sorteringsguide': 'Sorteringsguide',
    'hitta-avc': 'Hitta ÅVC',
    'station': 'Station',
    'rapportera-fel': 'Rapportera fel',
    'admin': 'Administration'
  };

  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center gap-2 text-sm text-neutral-600 flex-wrap">
        <li>
          <Link to="/" className="hover:text-primary-600 transition-colors" aria-label="Startsida">
            <FontAwesomeIcon icon={faHome} />
          </Link>
        </li>
        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          const displayName = breadcrumbNameMap[name] || decodeURIComponent(name);

          return (
            <React.Fragment key={routeTo}>
              <li aria-hidden="true">
                <FontAwesomeIcon icon={faChevronRight} className="text-xs text-neutral-400" />
              </li>
              <li>
                {isLast ? (
                  <span className="text-neutral-900 font-medium" aria-current="page">
                    {displayName}
                  </span>
                ) : (
                  <Link to={routeTo} className="hover:text-primary-600 transition-colors">
                    {displayName}
                  </Link>
                )}
              </li>
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
